export default __webpack_public_path__ + "1666ae7a8e5c0558fd204ae3ff5dacc4.png";